import * as Yup from 'yup';
import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import { SigninInputs, SigninErrors } from '../../../redux/auth/interfaces';
import { TextInput, SubmitButton } from '../form-elements';
import { withAnalytics, WithAnalyticsProps } from '../../../HOC/with-analytics';

interface FormValues extends SigninInputs {
  submit?: string;
}

type SignInProps = {
  isLoggedIn?: boolean;
  isSigningIn?: boolean;
  errors?: SigninErrors;
  loginUser: (data: SigninInputs) => void;
} & WithAnalyticsProps;

export const SignInForm: React.FC<SignInProps> = (props) => {
  const initialValues: FormValues = { username: '', password: '' };

  const formik = useFormik({
    initialValues,
    onSubmit: ({ username, password }) => {
      props.loginUser({ username, password });
    },
    validationSchema: Yup.object().shape({
      username: Yup.number()
        .typeError('Phone number is invalid')
        .required('Phone Number is required')
        .min(9, 'Phone number is too short'),
      password: Yup.string().required('Password is required'),
    }),
  });

  const _handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    props.sendAnalytics('clickSignin', 'Auth');
    formik.submitForm();
  };

  useEffect(() => {
    if (props.errors || props.isLoggedIn) {
      formik.setSubmitting(false);

      if (Object.keys(props.errors || {}).length > 0) formik.setErrors(props.errors);
    }
  }, [props.isSigningIn, props.isLoggedIn]);

  const { values, errors, touched, isSubmitting, ...formProps } = formik;

  return (
    <form className="" onSubmit={_handleSubmit}>
      <div className="form-row">
        <TextInput
          type="text"
          name="username"
          value={values.username}
          errors={errors.username}
          placeholder="Phone Number"
          handleBlur={formProps.handleBlur}
          handleChange={formProps.handleChange}
          hasError={errors.username && touched.username}
        />
      </div>

      <div className="form-row mt-2">
        <TextInput
          type="password"
          name="password"
          placeholder="Password"
          value={values.password}
          errors={errors.password}
          handleBlur={formProps.handleBlur}
          handleChange={formProps.handleChange}
          hasError={errors.password && touched.password}
        />
      </div>

      {(errors as SigninErrors).submit && (
        <div className="p-3 text-red-600 font-light bg-red-300 rounded text-sm my-4">
          {(errors as SigninErrors).submit}
        </div>
      )}

      <SubmitButton
        direction="right"
        title="Sign In"
        loadingMsg="Signing In..."
        isSubmitting={isSubmitting}
        isDirty={formProps.dirty}
      />
    </form>
  );
};

export default withAnalytics(SignInForm);
